import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  inject,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { TimelineModalFilterService } from '../../../services/timeline-modal-filter.service';
import { AssignmentAvailabilityStatus } from '@wilson/interfaces';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'wilson-user-shift-assignment-availability-filter',
  imports: [CommonModule, NzSelectModule, FormsModule, TranslateModule],
  templateUrl: './user-shift-assignment-availability-filter.component.html',
  styleUrls: ['./user-shift-assignment-availability-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserShiftAssignmentAvailabilityFilterComponent {
  private readonly cdRef = inject(ChangeDetectorRef);
  timelineModalFilterService = inject(TimelineModalFilterService);

  AssignmentAvailabilityStatus = AssignmentAvailabilityStatus;

  availableStaffChanged(staffAvailability: AssignmentAvailabilityStatus) {
    this.timelineModalFilterService.staffAvailabilityChanged(staffAvailability);
    this.cdRef.detectChanges();
  }
}
